import { render, staticRenderFns } from "./RedemptionsPopups.vue?vue&type=template&id=3235c744&"
import script from "./RedemptionsPopups.vue?vue&type=script&lang=js&"
export * from "./RedemptionsPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports